import { Select, Option, Scrollbar } from 'element-ui';
import Vue from 'vue';
import SelectInput from '../select-input/select-input.vue';
const SELECT_CHANGE_GTM_EVENT_NAME = 'dropDownSelect';
const UNKNOWN_FORM_ID = 'Unknown form id';
const UNKNOWN_FORM_ELEMENT_ID = 'Unknown form element id';

Vue.component(Option.name, Option);
Vue.component(Scrollbar.name, Scrollbar);
export default {
	extends: Select,
	components: {
		'select-input': SelectInput
	},
	inheritAttrs: false,
	props: {
		ariaControls: {
			required: false
		}
	},
	methods: {
		/*
			ez a method az element-ui.common.js libből van kimásolva 6074. sorból, csak e GTM miatt kell beleírni pluszban!
			a lib frissítése esetén érdemes ezt a függvényt újra kimásolni, és a megfelelő GTM részeket beleíírni
		*/
		handleOptionSelect: function handleOptionSelect(option) {
			let valueToGtm = null;
			var _this8 = this;

			if (this.multiple) {
				var value = this.value.slice();
				var optionIndex = this.getValueIndex(value, option.value);
				if (optionIndex > -1) {
					value.splice(optionIndex, 1);
				} else if (this.multipleLimit <= 0 || value.length < this.multipleLimit) {
					value.push(option.value);
				}
				this.$emit('input', value);
				valueToGtm = value;
				if (option.created) {
					this.query = '';
					this.inputLength = 20;
				}
				if (this.filterable) this.$refs.input.focus();
			} else {
				this.$emit('input', option.value);
				valueToGtm = option.label;
				this.visible = false;
			}
			this.$nextTick(function () {
				return _this8.scrollToOption();
			});

			let formId = this.$refs.reference && this.$refs.reference.$refs && this.$refs.reference.$refs.input &&
			this.$refs.reference.$refs.input.form && this.$refs.reference.$refs.input.form.id ? this.$refs.reference.$refs.input.form.id : UNKNOWN_FORM_ID;
			this.$gtm.trackEvent({
				event: SELECT_CHANGE_GTM_EVENT_NAME,
				formElementID: this.$attrs.id || UNKNOWN_FORM_ELEMENT_ID,
				formId,
				inputValue: valueToGtm
			});
		}
	}
};
